import { UserProfileDto } from '@buck-e-icp/interfaces';
import { createFeature, createReducer, on } from '@ngrx/store';

import { initialStateResult, ResultState, stateError, stateLoading, stateSuccess } from '../../shared/utils';
import { AUTH_FEATURE_NAME, AuthActions } from './auth.actions';

export interface AuthState {
    availableProfiles: ResultState<UserProfileDto[]>;
    activeProfile: ResultState<UserProfileDto | null>;
    // The e-mail the user logged in with, used to show which account is being resolved on the select-profile page.
    loginEmail: string | null;
}

export const initialState: AuthState = {
    availableProfiles: initialStateResult,
    activeProfile: initialStateResult,
    loginEmail: null,
};

export const authFeature = createFeature({
    name: AUTH_FEATURE_NAME,
    reducer: createReducer(
        initialState,
        on(
            AuthActions.startAutoLogin,
            AuthActions.logout,
            (state): AuthState => ({
                ...state,
                availableProfiles: stateLoading(initialState.availableProfiles.result),
                activeProfile: stateLoading(initialState.activeProfile.result),
            }),
        ),
        on(
            AuthActions.loginSuccess,
            (state, action): AuthState => ({
                ...state,
                availableProfiles: stateSuccess(action.availableProfiles),
                activeProfile: stateSuccess(action.activeProfile),
            }),
        ),
        on(
            AuthActions.logoutSuccess,
            (state): AuthState => ({
                ...state,
                availableProfiles: stateSuccess([]),
                activeProfile: stateSuccess(null),
                loginEmail: null,
            }),
        ),
        on(
            AuthActions.logoutFailed,
            AuthActions.loginFailed,
            (state, action): AuthState => ({
                ...state,
                availableProfiles: stateError(action.error, state.availableProfiles.result),
                activeProfile: stateError(action.error, state.activeProfile.result),
            }),
        ),
        on(
            AuthActions.selectProfile,
            (state, action): AuthState => ({
                ...state,
                availableProfiles: stateSuccess(action.profiles),
                loginEmail: action.email ?? state.loginEmail,
            }),
        ),
    ),
});
